import { render, staticRenderFns } from "./ActiveButtonWithArrow.vue?vue&type=template&id=535cb7c0&scoped=true&"
import script from "./ActiveButtonWithArrow.vue?vue&type=script&lang=js&"
export * from "./ActiveButtonWithArrow.vue?vue&type=script&lang=js&"
import style0 from "./ActiveButtonWithArrow.vue?vue&type=style&index=0&id=535cb7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cb7c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
